export default __webpack_public_path__ + "static/media/icon_zip.6f05bcf1.png";